export const SET_INCENTIVE_VALIDATION_ERROR = 'SET_INCENTIVE_VALIDATION_ERROR';
export const CLEAR_INCENTIVE_VALIDATION_ERROR = 'CLEAR_INCENTIVE_VALIDATION_ERROR';
